// extracted by mini-css-extract-plugin
export default {"channelAvatar":"ChannelAvatar_channelAvatar__LlrTn","isFailed":"ChannelAvatar_isFailed__X2xG5","defaultAvatar":"ChannelAvatar_defaultAvatar__RCVbK"};